var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('answer-render',{ref:"answer",attrs:{"config":_vm.config}},[_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('answer-option-list',{attrs:{"config":_vm.config,"prop":"value","answerValidate":_vm.answerValidate,"model":_vm.config,"optionKey":"optionName","optionValueKey":"id","multiple":true}})],1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-18485c67","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/editor/CheckBox/CheckBoxAnswer.vue
// module id = null
// module chunks = 